import React, { useState } from 'react';

const CopyPrompt = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCopy();
    }
  };

  return (
    <span
      className={`ml-3 cursor-pointer text-xl transition-colors duration-200 ${
        copied ? 'text-green-500' : 'text-gray-500'
      }`}
      title={copied ? 'Copied!' : 'Copy'}
      onClick={handleCopy}
      onKeyDown={handleKeyDown}
      aria-label={copied ? 'Text copied to clipboard' : 'Copy text to clipboard'}
      tabIndex={0}
      role="button"
    >
      {copied ? '✔️' : '📋'}
    </span>
  );
};

export default CopyPrompt; 